import { Box } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from '../../shared/button/button'
import { Dropdown } from '../../shared/dropdown/dropdown'
import { TextFieldStyled } from '../../shared/styles'

import { typeTransactions } from '../mockedData'

import { useGetUser } from '../../hooks/useGetUser'
import { getAgenda } from '../../redux/actions/agenda.actions'

export const FiltersTransactions = ({
  filters,
  setFilters,
  handleGetTransactions,
  credentialId,
}) => {
  const dispatch = useDispatch()

  const { user } = useGetUser()

  const { data: agenda } = useSelector((state) => state.agenda)

  useEffect(() => {
    if (user?.usuarioid) {
      dispatch(getAgenda(user.usuarioid, 1, 100000))
    }
  }, [dispatch, user?.usuarioid])

  const agendaFormatted = agenda.map((contact) => ({
    value: contact.walletadress,
    label: `${contact?.alias} - ${contact?.nombre} ${
      contact?.apellido || ''
    }`,
  }))

  function handleSelectTransactionType(value) {
    setFilters({ ...filters, transactionType: value })
  }

  return (
    <Box
      display={'flex'}
      gap={'8px'}
      alignItems={'flex-start'}
      mt={'16px'}
      flexWrap={'wrap'}
    >
      <Box minWidth={'180px'}>
        <Box height={'22px'} />
        <Dropdown
          withSearch={false}
          options={typeTransactions}
          width={'180px'}
          defaultValue={filters.transactionType}
          onSelect={handleSelectTransactionType}
        />
      </Box>

      {agenda.length > 0 && (
        <>
          <Box minWidth={'240px'}>
            <Box height={'22px'}>From contact</Box>

            <Dropdown
              withSearch={false}
              options={agendaFormatted}
              defaultValue={filters?.from_address}
              onSelect={(wallet) =>
                setFilters({
                  ...filters,
                  from_address: wallet,
                })
              }
              styles={{
                width: '240px',
              }}
            />
          </Box>

          <Box minWidth={'240px'}>
            <Box height={'22px'}>To contact</Box>

            <Dropdown
              withSearch={false}
              options={agendaFormatted}
              defaultValue={filters?.to_address}
              onSelect={(wallet) =>
                setFilters({
                  ...filters,
                  to_address: wallet,
                })
              }
              styles={{
                width: '240px',
              }}
            />
          </Box>
        </>
      )}

      <Box minWidth={'220px'}>
        <Box height={'22px'} />

        <TextFieldStyled
          name={'from_address'}
          placeholder={'From address'}
          type={'text'}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{ width: '220px' }}
          value={filters.from_address}
          onChange={(e) =>
            setFilters({
              ...filters,
              from_address: e.target.value,
            })
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleGetTransactions(null, credentialId)
            }
          }}
        />
      </Box>

      <Box minWidth={'220px'}>
        <Box height={'22px'} />

        <TextFieldStyled
          name={'to_address'}
          placeholder={'To address'}
          type={'text'}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{ width: '220px' }}
          value={filters.to_address}
          onChange={(e) =>
            setFilters({
              ...filters,
              to_address: e.target.value,
            })
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleGetTransactions(null, credentialId)
            }
          }}
        />
      </Box>

      <Box minWidth={'220px'}>
        <Box height={'22px'} />

        <TextFieldStyled
          name={'tx_hash'}
          placeholder={'tx_hash'}
          type={'text'}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{ width: '220px' }}
          value={filters.tx_hash}
          onChange={(e) =>
            setFilters({
              ...filters,
              tx_hash: e.target.value,
            })
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleGetTransactions(null, credentialId)
            }
          }}
        />
      </Box>

      <Box>
        <Box height={'22px'} />

        <Button
          label={'Search'}
          onClick={() => handleGetTransactions(null, credentialId)}
        />
      </Box>
    </Box>
  )
}